// extracted by mini-css-extract-plugin
export default {"Picture":"Picture_Picture__JE4PP","Picture_ToLeft":"Picture_Picture_ToLeft__jwQ3R"};